module.exports = __webpack_public_path__ + "136621b251aae19291e1740f6046973f.fbx";